// extracted by mini-css-extract-plugin
export var addToCartButton = "_oj-b";
export var arrowButtonContainer = "_oj-9";
export var arrowButtonIcon = "_oj-a";
export var carouselArrowButton = "_oj-6";
export var carouselElementContainer = "_oj-1";
export var galleryThumbnail = "_oj-d";
export var galleryThumbnailImage = "_oj-e";
export var left = "_oj-7";
export var productDisplayCarouselContainer = "_oj-0";
export var productTileContainer = "_oj-2";
export var productTileImage = "_oj-4";
export var productTileImageContainer = "_oj-3";
export var productTileTitle = "_oj-5";
export var right = "_oj-8";
export var sliderOverflow = "_oj-c";